export const DrupalSiteStatus = {
  INITIALIZING: 'initializing',
  BROKEN: 'broken',
  OK: 'ok',
};

export const WordPressSiteStatus = {
  INITIALIZING: 'initializing',
  BROKEN: 'broken',
  OK: 'ok',
};

export const WordPressSiteSSOStatus = {
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
  FORCED: 'Forced',
};

export const ProjectCategories = {
  OFFICIAL: 'Official',
  PERSONAL: 'Personal',
  TEST: 'Test',
};
